import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMessageSquare, FiCpu, FiSparkles, FiSend } = FiIcons;

const AIAdvisor = () => {
  const [query, setQuery] = useState('');
  const [isAsking, setIsAsking] = useState(false);
  const [response, setResponse] = useState('');

  const handleAsk = (e) => {
    e.preventDefault();
    if (!query) return;
    setIsAsking(true);
    setResponse('');
    
    setTimeout(() => {
      setIsAsking(false);
      setResponse("Based on your goals, maximizing Account 2 for housing or education while letting Account 1 grow for retirement is the recommended strategy. Ensure you have at least 6 months of emergency savings before increasing voluntary contributions.");
    }, 1500);
  };

  return (
    <section id="ai-advisor" className="py-24 bg-slate-900 text-white relative overflow-hidden">
      {/* Techy background effect */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_50%_50%,#3b82f6_0%,transparent_50%)]"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-brand-500/10 text-brand-400 mb-6 border border-brand-500/20">
            <SafeIcon icon={FiCpu} className="w-8 h-8" />
          </div>
          <h2 className="text-4xl font-bold mb-4 tracking-tight">AI Retirement Advisor</h2>
          <p className="text-slate-400 text-lg">Have specific questions about your EPF strategy? <br />Ask our experimental assistant.</p>
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-slate-800/40 backdrop-blur-xl p-8 rounded-[2.5rem] border border-slate-700/50 shadow-2xl"
        >
          <form onSubmit={handleAsk} className="relative">
            <textarea
              className="w-full bg-slate-950/50 border border-slate-700 rounded-2xl p-6 text-slate-100 placeholder:text-slate-600 focus:ring-4 focus:ring-brand-500/20 focus:border-brand-500 transition-all resize-none mb-4 min-h-[120px] text-lg"
              placeholder="e.g. Should I withdraw from Account 2 for a home downpayment?"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            ></textarea>
            
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 text-slate-500 text-xs font-medium uppercase tracking-[0.2em]">
                <SafeIcon icon={FiSparkles} className="text-brand-400" />
                Experimental Beta
              </div>
              <button
                type="submit"
                disabled={isAsking || !query}
                className="inline-flex items-center px-8 py-3 rounded-xl bg-brand-600 text-white font-bold hover:bg-brand-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-lg shadow-brand-600/20"
              >
                {isAsking ? 'Analyzing...' : 'Ask Advisor'}
                {!isAsking && <SafeIcon icon={FiSend} className="ml-2 w-4 h-4" />}
              </button>
            </div>
          </form>

          <AnimatePresence>
            {response && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className="mt-8 pt-8 border-t border-slate-700/50"
              >
                <div className="flex gap-5">
                  <div className="w-10 h-10 rounded-full bg-brand-500/20 flex items-center justify-center flex-shrink-0 text-brand-400 border border-brand-500/30">
                    <SafeIcon icon={FiMessageSquare} className="w-5 h-5" />
                  </div>
                  <div className="space-y-4">
                    <p className="text-slate-200 text-lg leading-relaxed italic">
                      "{response}"
                    </p>
                    <p className="text-xs text-slate-500 font-medium">
                      Disclaimer: AI responses are for informational purposes only. Consult a financial planner for professional advice.
                    </p>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};

export default AIAdvisor;